// Short-lived, memory-only cache for list navigation. Never cache credentials,
// documents, banking, or arbitrary API requests.
const paths = new Set(['/customers', '/assignments', '/assignments?include_deleted=true', '/invoices?include_deleted=true', '/integrationsaemter']);
export function installNavigationCache(client, session = () => localStorage.getItem('token')) {
  const entries = new Map();
  let owner;
  let generation = 0;
  const invalidate = () => { entries.clear(); generation += 1; };
  const get = client.get.bind(client);
  client.get = (url, config = {}) => {
    const token = session();
    if (owner !== token) { invalidate(); owner = token; }
    if (!token || !paths.has(url) || config.params || config.signal || config.responseType || config.baseURL || config.headers) return get(url, config);
    const now = Date.now();
    const entry = entries.get(url);
    if (entry && (entry.pending || entry.expires > now)) return entry.promise.then(copy);
    const version = generation;
    const next = { pending: true, expires: 0 };
    next.promise = get(url, { timeout: 15000, ...config }).then(response => {
      next.pending = false;
      next.expires = Date.now() + 15000;
      if (version !== generation && entries.get(url) === next) entries.delete(url);
      return response;
    }, error => { if (entries.get(url) === next) entries.delete(url); throw error; });
    entries.set(url, next);
    return next.promise.then(copy);
  };
  return invalidate;
}
const copy = response => ({ ...response, data: JSON.parse(JSON.stringify(response.data)) });
export async function preloadNavigation(client, cancelled) {
  // Two workers keep a slow list from blocking every other tab. The assignment
  // screen uses include_deleted; preloading both variants downloads it twice.
  const queue = ['/customers', '/assignments?include_deleted=true', '/invoices?include_deleted=true', '/integrationsaemter'];
  const worker = async () => {
    while (queue.length && !cancelled() && document.visibilityState === 'visible') {
      const path = queue.shift();
      try { await client.get(path); } catch { /* Other lists can still be available. */ }
    }
  };
  await Promise.all([worker(), worker()]);
}
